//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 11/07/2025
// Version : 1
// Description : Pantalla principal de estadisticas de stock sucursales
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import Stock_actual from "./Stock_actual";
import Evolucion_mensual from "./Evolucion_mensual";
import Total_x_planta from "./Total_x_planta";
import Destino_Insumos from "./Destino_Insumos";
import Planta_Mayor_Demanda from "./Planta_Mayor_Demanda";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function PanelPrincipal({ setGrafico, setTabla }) {
  const handleClose = () => {
    setGrafico(false);
    setTabla(true);
  };

  // sucursales
  const [sucursalesDisponibles, setSucursalesDisponibles] = useState([]);
  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState([]);

  // Fetch general
  const obtenerSucursales = () => {
    fetch(UrlApi + "/sucursales")
      .then((res) => res.json())
      .then((data) => setSucursalesDisponibles(data));
  };

  useEffect(() => {
    obtenerSucursales();
  }, []);

  return (
    <div>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* ENCABEZADO */}
        <Box
          sx={{
            bgcolor: "#2B76A6",
            color: "white",
            position: "relative",
            textAlign: "center",
            px: 2,
            py: 2,
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              left: 8,
              top: 8,
              color: "white",
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" fontWeight="bold">
            Panel principal
          </Typography>
        </Box>

        {/* CUERPO */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            p: 1,
            gap: 1,
          }}
        >
          {/* FILA 1: tres columnas */}
          {/* FILA 1: tres columnas */}
          <Grid container spacing={1} sx={{ flex: 1 }}>
            {[
              <Stock_actual sucursalesDisponibles={sucursalesDisponibles} />,
              <Evolucion_mensual
                sucursalesDisponibles={sucursalesDisponibles}
              />,
              <Planta_Mayor_Demanda />,
            ].map((Comp, i) => (
              <Grid item key={i} xs={12} sm={6} md={4} display="flex">
                <Card
                  sx={{
                    flex: 1,
                    borderRadius: 3,
                    boxShadow: 4,
                    backgroundColor: "#DEDEDE",
                    border: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  <CardContent
                    sx={{
                      width: "100%",
                      height: "100%",
                      p: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {Comp}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          {/* FILA 2: dos columnas */}
          {/* SEGUNDA FILA - Rectangulares más chicas */}
          <Grid
            container
            item
            xs={12}
            spacing={1}
            justifyContent="center"
            alignItems="stretch"
          >
            {[<Destino_Insumos />, <Total_x_planta />].map((Comp, index) => (
              <Grid
                item
                key={index}
                xs={12}
                sm={6}
                md={6}
                display="flex"
                justifyContent="center"
                alignItems="stretch"
              >
                <Card
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    boxShadow: 2,
                    backgroundColor: "#DEDEDE",
                    border: "1px solid #999",
                    height: "100%",
                    maxHeight: 160,
                    overflow: "hidden",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CardContent
                    sx={{
                      padding: "8px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                      height: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {Comp}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      {/* Botón volver */}
      {/* <Grid item marginBottom={7} marginLeft={2}>
        <Button variant="contained" onClick={handleClose} color="error">
          Volver
        </Button>
      </Grid> */}
    </div>
  );
}

export default PanelPrincipal;
